import {
  API_ERROR,
  QUALITY,
  QUALITY_LIST_SUCCESSFUL,
  QUALITY_ADD,
  QUALITY_ADD_SUCCESSFUL,
  QUALITY_EDIT,
  QUALITY_EDIT_SUCCESSFUL,
  QUALITY_DELETE,
  QUALITY_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  qualitylist: [],
  model: false,
  error_msg: null,
  rowdata: {},
};

const quality = (state = initialState, action) => {
  switch (action.type) {
    case QUALITY:
      state = {
        ...state,
        loading: true,
      };
      break;
    case QUALITY_LIST_SUCCESSFUL:
      state = {
        ...state,
        qualitylist: action.payload.response.results,
        loading: false,
      };
      break;
    case QUALITY_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case QUALITY_ADD_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        // rowdata: {Id:0},
      };
      break;
    case QUALITY_EDIT:
      state = {
        ...state,
        model: true,
        rowdata: action.payload,
      };
      break;
    case QUALITY_EDIT_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        rowdata: {Id:0},
      };
      break;
    case QUALITY_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case QUALITY_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default quality;
